export default {
  companyUrl: 'https://demo-www.lwtears.com',
  digitalAssetsUrl: 'https://a-z-educator-content-demo.lwtears.com',
};
